import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div data-testid="loading-screen" className="min-h-screen flex items-center justify-center">
        <div className="glass rounded-2xl px-6 py-4 text-slate-300 font-heading tracking-wider">Loading WrapConsole…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to="/" replace />;
  return children;
}
